import { environmentVariables } from '../utils/environmentVariables'
import { getLocale } from '../i18n/detect-locale'

const CLIENT_ID = environmentVariables('COOKIES_CLIENT_ID')
const COOKIES_VERSIONS: { [key: string]: string } = {
  "fr-FR": "fr-eu-08-10-2025",
  "en-US": "en-eu-08-10-2025",
}
const DEFAULT_COOKIES_VERSION = COOKIES_VERSIONS["en-US"]
const DISABLED = environmentVariables('COOKIES_BANNER_ENABLED') === 'false'

interface AxeptioSettings {
  clientId: string
  cookiesVersion: string
  userCookiesDomain: string
  googleConsentMode: {
    default: {
      analytics_storage: string
      ad_storage: string
      ad_user_data: string
      ad_personalization: string
      wait_for_update: number
    }
  }
}

declare global {
  interface Window {
    axeptioSettings: AxeptioSettings
  }
}

const getCookiesVersion = (): string => {
  const locale = getLocale()
  return COOKIES_VERSIONS[locale] || DEFAULT_COOKIES_VERSION
}

/**
 * Clean subdomain-specific axeptio cookies, keeping only the root domain cookie (.swile.co)
 * This ensures we only have cookies set at the root domain level (e.g., directory.swile.co cookies are removed)
 * Context: duplicated axeptio cookies are leading to nginx 400 errors "Request Header Or Cookie Too Large"
 */
const cleanupDuplicateCookies = (): void => {
  if (!document.cookie) {
    return
  }

  const axeptioCookies = ['axeptio_cookies', 'axeptio_authorized_vendors', 'axeptio_all_vendors']

  axeptioCookies.forEach((cookieName) => {
    // Always expire the subdomain-specific cookie to keep only the root domain cookie (.swile.co)
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${window.location.hostname}`
  })
}

export const loadAxeptio = (): void => {
  if (DISABLED) {
    return
  }

  cleanupDuplicateCookies()

  window.axeptioSettings = {
    clientId: CLIENT_ID,
    cookiesVersion: getCookiesVersion(),
    userCookiesDomain: 'swile.co',
    googleConsentMode: {
      default: {
        analytics_storage: "denied",
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        wait_for_update: 500
      }
    }
  }

  const script = document.createElement('script')
  script.src = '//static.axept.io/sdk.js'
  script.async = true
  document.head.appendChild(script)
}
